import { AlertTriangle } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgExclamationSolid = mkIcon(AlertTriangle);